import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Wraps protected routes — non-logged-in users are bounced to /login.
export default function RequireAuth({ children }) {
    const { user, ready } = useAuth();
    const loc = useLocation();
    if (!ready) return <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center text-white/50 font-mono-tag text-sm">Loading...</div>;
    if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
    return children;
}
